module.exports = __webpack_public_path__ + "static/media/v6.9deef257.JPG";